import { render, staticRenderFns } from "./doingclients.vue?vue&type=template&id=2c396fd0&"
import script from "./doingclients.vue?vue&type=script&lang=js&"
export * from "./doingclients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports